<div id="openExtendsAvailableBedrooms" class="modal fade in" tabindex="-1" role="dialog" data-backdrop="static"
  data-keyboard="false">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title mt-0" id="mySmallModalLabel">Listar Habitaciones disponibles
        </h5>
      </div>
      <app-loading-modal></app-loading-modal>
      <ng-container *ngIf="isSearch">
        <div class="modal-body">
          <div class="row">
            <div class="form-group col-lg-8">
              <label> <i class="fas fa-plane-arrival"></i> CHECKIN <span class="m-l-5">/</span> <i
                  class="fas fa-plane-departure m-l-15"></i> CHECKOUT</label>
              <div class="input-group" style="width: 105%;">
                <span class="input-group-prepend">
                  <span class="input-group-text content__subhead__inputGrid__title">
                    <i class="far fa-calendar-alt"></i>
                  </span>
                </span>
                <input type="text" id="date_range" class="form-control form-control-sm">
              </div>
            </div>
            <div class="form-group col-lg-2">
              <label>#Noches <span class="required"></span></label>
              <input type="text" class="form-control form-control-sm text-center" id="number_nights"
                [(ngModel)]="number_nights" numeric>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12" *ngIf="bedrooms.length == 0">
              <p>Aplicar fecha para listar habitaciones disponibles</p>
            </div>
            <div class="col-lg-12" *ngIf="bedrooms.length > 0">
              <div class="m-t-0 m-b-10">
                <span class="badge badge-success f-s-11">Habitaciones Disponibles</span>
              </div>
              <div class="table-responsive">
                <table class="table mb-0 table-hover">
                  <thead class="thead-default">
                    <tr>
                      <th class="text-center">N° HAB</th>
                      <th>TIPO</th>
                      <th>N°Pax</th>
                      <th>Variaciones</th>
                      <th class="text-center">#Piso</th>
                      <!-- <th>Estado</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngIf="bedrooms.length == 0">
                      <tr>
                        <td colspan="4"><span>Aun no se han agregado huéspedes</span></td>
                      </tr>
                    </ng-container>
                    <ng-container *ngIf="bedrooms.length > 0">
                      <tr *ngFor="let item of bedrooms; let index_ = index">
                        <td class="text-center">
                          <div class="custom-control custom-checkbox" style="display: inline-flex;">
                            <input class="custom-control-input" type="checkbox" value="{{item.id}}"
                              id="bedroom_available{{item.id}}" (change)="selectedBedrooms(item)">
                            <label class="custom-control-label p-t-3 bold f-s-12" for="bedroom_available{{item.id}}">
                              {{item.code_number}}
                            </label>
                          </div>
                        </td>
                        <td>
                          <label for="bedroom_available{{item.id}}"
                            class="f-s-12 pointer">{{item.roomtype.description}}</label>
                        </td>
                        <td>{{item.roomtype.capacity}}</td>
                        <td>
                          <ng-container *ngIf="item.is_variation_roomtype">
                            (<ng-container *ngFor="let variation of item.bedroom_variations">
                              <span class="f-s-10">{{variation.roomtype.description}}</span>,
                            </ng-container>
                            )
                            <span></span>
                          </ng-container>
                          <ng-container *ngIf="!item.is_variation_roomtype">
                            <span>No</span>
                          </ng-container>
                        </td>
                        <td class="text-center">{{item.floor}}</td>
                        <!-- <td>
                          <span class="badge badge-success f-s-11">Disponible</span>
                        </td> -->
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer nowrap">
          <button type="button" class="btn btn-secondary close-btn" data-dismiss="modal" (click)="close()">Cerrar
            ventana</button>
          <ng-container *ngIf="bedroom_selecteds.length > 0">
            <button type="button" class="btn btn-primary" (click)="onSubmit()">
              Agregar
              (<span>{{bedroom_selecteds.length}}</span> seleccionados)
              <i class="fas fa-plus m-l-5"></i>
            </button>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</div>
